module.exports = __webpack_public_path__ + "static/media/NoirPro-Bold.bb9d0cc6.woff2";